import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { formatDate } from "@/lib/format";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  recipientName: string;
  recipientEmail: string | null;
  formSentAt: string | null;
}

/**
 * VIB-1281: skilt ut fra ExtraDetailRow (som var i ferd med å passere
 * 300-linjersgrensen) — ren presentasjonskomponent, ingen egen state utover
 * det som styres av caller. Bevarer eksisterende tekst/oppførsel 1:1.
 */
export default function SendFormConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  recipientName,
  recipientEmail,
  formSentAt,
}: Props) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Send skjema til {recipientName}?</AlertDialogTitle>
          <AlertDialogDescription>
            {formSentAt
              ? `Skjema ble sist sendt ${formatDate(formSentAt)}. Sender du nytt blir gammel lenke ugyldig.`
              : `En e-post med skjema-lenke sendes til ${recipientEmail}.`}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Avbryt</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Send</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
